










import { defineComponent, PropType, toRefs, watch } from '@nuxtjs/composition-api'

import useProxyValue from '@/composables/use-proxy-value'

export default defineComponent({
  props: {
    value: {
      type: Boolean as PropType<boolean | null>,
      default: null,
    },
    hideTitle: {
      type: Boolean,
      default: false,
    },
  },
  setup (props, { emit }) {
    const { proxyValue } = useProxyValue(toRefs(props).value, emit)

    watch(proxyValue, (value) => {
      emit('update', value)
    }, { immediate: true })

    return {
      proxyValue,
    }
  },
})
